// src/components/editorToolbar.js

// Inline style map para fuentes personalizadas
export const STYLE_MAP = {
  'FONTFAMILY-Inter': { fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif' },
  'FONTFAMILY-SystemUI': { fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif' },
  'FONTFAMILY-Roboto': { fontFamily: 'Roboto, Helvetica, Arial, sans-serif' },
  'FONTFAMILY-OpenSans': { fontFamily: '"Open Sans", Helvetica, Arial, sans-serif' },
  'FONTFAMILY-DMSans': { fontFamily: '"DM Sans", Inter, system-ui, sans-serif' },
  'FONTFAMILY-Poppins': { fontFamily: 'Poppins, Inter, system-ui, sans-serif' },
  'FONTFAMILY-Montserrat': { fontFamily: 'Montserrat, Inter, system-ui, sans-serif' },
  'FONTFAMILY-Lato': { fontFamily: 'Lato, Helvetica, Arial, sans-serif' },
  'FONTFAMILY-Nunito': { fontFamily: 'Nunito, Inter, system-ui, sans-serif' },
  'FONTFAMILY-Raleway': { fontFamily: 'Raleway, Inter, system-ui, sans-serif' },
  'FONTFAMILY-WorkSans': { fontFamily: '"Work Sans", Inter, system-ui, sans-serif' },
  'FONTFAMILY-SpaceGrotesk': { fontFamily: '"Space Grotesk", Inter, system-ui, sans-serif' },
  'FONTFAMILY-Rubik': { fontFamily: 'Rubik, Inter, system-ui, sans-serif' },

  'FONTFAMILY-Georgia': { fontFamily: 'Georgia, serif' },
  'FONTFAMILY-TimesNewRoman': { fontFamily: '"Times New Roman", Times, serif' },
  'FONTFAMILY-Merriweather': { fontFamily: 'Merriweather, Georgia, serif' },
  'FONTFAMILY-Playfair': { fontFamily: '"Playfair Display", Georgia, serif' },
  'FONTFAMILY-LibreBaskerville': { fontFamily: '"Libre Baskerville", Georgia, serif' },
  'FONTFAMILY-NotoSerif': { fontFamily: '"Noto Serif", Georgia, serif' },

  'FONTFAMILY-NotoSans': { fontFamily: '"Noto Sans", Inter, system-ui, sans-serif' },
  'FONTFAMILY-Oswald': { fontFamily: 'Oswald, Arial Narrow, Arial, sans-serif' },

  'FONTFAMILY-JetBrainsMono': { fontFamily: '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono","Courier New", monospace' },
  'FONTFAMILY-FiraCode': { fontFamily: '"Fira Code", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono","Courier New", monospace' },
  'FONTFAMILY-Mono': { fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono","Courier New", monospace' },
}

// Mantén tu toolbar como lo tenías (sin fontFamily nativo)
export const EDITOR_TOOLBAR = {
  options: ['inline', 'blockType', 'fontSize', 'colorPicker', 'list', 'textAlign', 'remove', 'history'],
  inline: { options: ['bold','italic','underline','strikethrough'] },
  blockType: { inDropdown: true },
  fontSize: { options: [12, 14, 16, 18, 20, 24, 28, 32, 36] },
  colorPicker: {
    colors: ['#111111','#1f2937','#4b5563','#9ca3af','#ffffff','#2563eb','#0ea5e9','#10b981','#f59e0b','#ef4444','#7c3aed'],
  },
}
